import NoResults from "./NoResults";
import TextNotAnnotatedByGroup from "./TextNotAnnotatedByGroup";
import TextNotAnnotatedByMe from "./TextNotAnnotatedByMe";

export default {
  NoResults,
  TextNotAnnotatedByGroup,
  TextNotAnnotatedByMe
};
